/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkItemsRouteImport } from './routes/work-items'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as TechnicalUncertaintyRouteImport } from './routes/technical-uncertainty'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SessionsRouteImport } from './routes/sessions'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as PromptsRouteImport } from './routes/prompts'
import { Route as InvestorRouteImport } from './routes/investor'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as ImportRouteImport } from './routes/import'
import { Route as GitRouteImport } from './routes/git'
import { Route as EffortRouteImport } from './routes/effort'
import { Route as DecisionsRouteImport } from './routes/decisions'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ContributorsRouteImport } from './routes/contributors'
import { Route as ComplianceRouteImport } from './routes/compliance'
import { Route as ClassifierTuningRouteImport } from './routes/classifier-tuning'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as AiReportsRouteImport } from './routes/ai-reports'
import { Route as AiModelsRouteImport } from './routes/ai-models'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as SignupSuccessRouteImport } from './routes/signup_.success'
import { Route as SignupAuthenticateRouteImport } from './routes/signup_.authenticate'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as PromptsPromptKeyRouteImport } from './routes/prompts.$promptKey'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects.$projectId'

const WorkItemsRoute = WorkItemsRouteImport.update({
  id: '/work-items',
  path: '/work-items',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const TechnicalUncertaintyRoute = TechnicalUncertaintyRouteImport.update({
  id: '/technical-uncertainty',
  path: '/technical-uncertainty',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsRoute = SessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const PromptsRoute = PromptsRouteImport.update({
  id: '/prompts',
  path: '/prompts',
  getParentRoute: () => rootRouteImport,
} as any)
const InvestorRoute = InvestorRouteImport.update({
  id: '/investor',
  path: '/investor',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportRoute = ImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => rootRouteImport,
} as any)
const GitRoute = GitRouteImport.update({
  id: '/git',
  path: '/git',
  getParentRoute: () => rootRouteImport,
} as any)
const EffortRoute = EffortRouteImport.update({
  id: '/effort',
  path: '/effort',
  getParentRoute: () => rootRouteImport,
} as any)
const DecisionsRoute = DecisionsRouteImport.update({
  id: '/decisions',
  path: '/decisions',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ContributorsRoute = ContributorsRouteImport.update({
  id: '/contributors',
  path: '/contributors',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplianceRoute = ComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassifierTuningRoute = ClassifierTuningRouteImport.update({
  id: '/classifier-tuning',
  path: '/classifier-tuning',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AiReportsRoute = AiReportsRouteImport.update({
  id: '/ai-reports',
  path: '/ai-reports',
  getParentRoute: () => rootRouteImport,
} as any)
const AiModelsRoute = AiModelsRouteImport.update({
  id: '/ai-models',
  path: '/ai-models',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupSuccessRoute = SignupSuccessRouteImport.update({
  id: '/signup_/success',
  path: '/signup/success',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupAuthenticateRoute = SignupAuthenticateRouteImport.update({
  id: '/signup_/authenticate',
  path: '/signup/authenticate',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PromptsPromptKeyRoute = PromptsPromptKeyRouteImport.update({
  id: '/$promptKey',
  path: '/$promptKey',
  getParentRoute: () => PromptsRoute,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai-models': typeof AiModelsRoute
  '/ai-reports': typeof AiReportsRoute
  '/audit': typeof AuditRoute
  '/billing': typeof BillingRoute
  '/classifier-tuning': typeof ClassifierTuningRoute
  '/compliance': typeof ComplianceRoute
  '/contributors': typeof ContributorsRoute
  '/dashboard': typeof DashboardRoute
  '/decisions': typeof DecisionsRoute
  '/effort': typeof EffortRoute
  '/git': typeof GitRoute
  '/import': typeof ImportRoute
  '/integrations': typeof IntegrationsRoute
  '/investor': typeof InvestorRoute
  '/prompts': typeof PromptsRouteWithChildren
  '/reports': typeof ReportsRoute
  '/sessions': typeof SessionsRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/technical-uncertainty': typeof TechnicalUncertaintyRoute
  '/welcome': typeof WelcomeRoute
  '/work-items': typeof WorkItemsRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/prompts/$promptKey': typeof PromptsPromptKeyRoute
  '/share/$token': typeof ShareTokenRoute
  '/signup/authenticate': typeof SignupAuthenticateRoute
  '/signup/success': typeof SignupSuccessRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai-models': typeof AiModelsRoute
  '/ai-reports': typeof AiReportsRoute
  '/audit': typeof AuditRoute
  '/billing': typeof BillingRoute
  '/classifier-tuning': typeof ClassifierTuningRoute
  '/compliance': typeof ComplianceRoute
  '/contributors': typeof ContributorsRoute
  '/dashboard': typeof DashboardRoute
  '/decisions': typeof DecisionsRoute
  '/effort': typeof EffortRoute
  '/git': typeof GitRoute
  '/import': typeof ImportRoute
  '/integrations': typeof IntegrationsRoute
  '/investor': typeof InvestorRoute
  '/prompts': typeof PromptsRouteWithChildren
  '/reports': typeof ReportsRoute
  '/sessions': typeof SessionsRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/technical-uncertainty': typeof TechnicalUncertaintyRoute
  '/welcome': typeof WelcomeRoute
  '/work-items': typeof WorkItemsRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/prompts/$promptKey': typeof PromptsPromptKeyRoute
  '/share/$token': typeof ShareTokenRoute
  '/signup/authenticate': typeof SignupAuthenticateRoute
  '/signup/success': typeof SignupSuccessRoute
  '/projects': typeof ProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai-models': typeof AiModelsRoute
  '/ai-reports': typeof AiReportsRoute
  '/audit': typeof AuditRoute
  '/billing': typeof BillingRoute
  '/classifier-tuning': typeof ClassifierTuningRoute
  '/compliance': typeof ComplianceRoute
  '/contributors': typeof ContributorsRoute
  '/dashboard': typeof DashboardRoute
  '/decisions': typeof DecisionsRoute
  '/effort': typeof EffortRoute
  '/git': typeof GitRoute
  '/import': typeof ImportRoute
  '/integrations': typeof IntegrationsRoute
  '/investor': typeof InvestorRoute
  '/prompts': typeof PromptsRouteWithChildren
  '/reports': typeof ReportsRoute
  '/sessions': typeof SessionsRoute
  '/settings': typeof SettingsRoute
  '/signup': typeof SignupRoute
  '/technical-uncertainty': typeof TechnicalUncertaintyRoute
  '/welcome': typeof WelcomeRoute
  '/work-items': typeof WorkItemsRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/prompts/$promptKey': typeof PromptsPromptKeyRoute
  '/share/$token': typeof ShareTokenRoute
  '/signup_/authenticate': typeof SignupAuthenticateRoute
  '/signup_/success': typeof SignupSuccessRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai-models'
    | '/ai-reports'
    | '/audit'
    | '/billing'
    | '/classifier-tuning'
    | '/compliance'
    | '/contributors'
    | '/dashboard'
    | '/decisions'
    | '/effort'
    | '/git'
    | '/import'
    | '/integrations'
    | '/investor'
    | '/prompts'
    | '/reports'
    | '/sessions'
    | '/settings'
    | '/signup'
    | '/technical-uncertainty'
    | '/welcome'
    | '/work-items'
    | '/projects/$projectId'
    | '/prompts/$promptKey'
    | '/share/$token'
    | '/signup/authenticate'
    | '/signup/success'
    | '/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai-models'
    | '/ai-reports'
    | '/audit'
    | '/billing'
    | '/classifier-tuning'
    | '/compliance'
    | '/contributors'
    | '/dashboard'
    | '/decisions'
    | '/effort'
    | '/git'
    | '/import'
    | '/integrations'
    | '/investor'
    | '/prompts'
    | '/reports'
    | '/sessions'
    | '/settings'
    | '/signup'
    | '/technical-uncertainty'
    | '/welcome'
    | '/work-items'
    | '/projects/$projectId'
    | '/prompts/$promptKey'
    | '/share/$token'
    | '/signup/authenticate'
    | '/signup/success'
    | '/projects'
  id:
    | '__root__'
    | '/'
    | '/ai-models'
    | '/ai-reports'
    | '/audit'
    | '/billing'
    | '/classifier-tuning'
    | '/compliance'
    | '/contributors'
    | '/dashboard'
    | '/decisions'
    | '/effort'
    | '/git'
    | '/import'
    | '/integrations'
    | '/investor'
    | '/prompts'
    | '/reports'
    | '/sessions'
    | '/settings'
    | '/signup'
    | '/technical-uncertainty'
    | '/welcome'
    | '/work-items'
    | '/projects/$projectId'
    | '/prompts/$promptKey'
    | '/share/$token'
    | '/signup_/authenticate'
    | '/signup_/success'
    | '/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiModelsRoute: typeof AiModelsRoute
  AiReportsRoute: typeof AiReportsRoute
  AuditRoute: typeof AuditRoute
  BillingRoute: typeof BillingRoute
  ClassifierTuningRoute: typeof ClassifierTuningRoute
  ComplianceRoute: typeof ComplianceRoute
  ContributorsRoute: typeof ContributorsRoute
  DashboardRoute: typeof DashboardRoute
  DecisionsRoute: typeof DecisionsRoute
  EffortRoute: typeof EffortRoute
  GitRoute: typeof GitRoute
  ImportRoute: typeof ImportRoute
  IntegrationsRoute: typeof IntegrationsRoute
  InvestorRoute: typeof InvestorRoute
  PromptsRoute: typeof PromptsRouteWithChildren
  ReportsRoute: typeof ReportsRoute
  SessionsRoute: typeof SessionsRoute
  SettingsRoute: typeof SettingsRoute
  SignupRoute: typeof SignupRoute
  TechnicalUncertaintyRoute: typeof TechnicalUncertaintyRoute
  WelcomeRoute: typeof WelcomeRoute
  WorkItemsRoute: typeof WorkItemsRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ShareTokenRoute: typeof ShareTokenRoute
  SignupAuthenticateRoute: typeof SignupAuthenticateRoute
  SignupSuccessRoute: typeof SignupSuccessRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/work-items': {
      id: '/work-items'
      path: '/work-items'
      fullPath: '/work-items'
      preLoaderRoute: typeof WorkItemsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/technical-uncertainty': {
      id: '/technical-uncertainty'
      path: '/technical-uncertainty'
      fullPath: '/technical-uncertainty'
      preLoaderRoute: typeof TechnicalUncertaintyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions': {
      id: '/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof SessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prompts': {
      id: '/prompts'
      path: '/prompts'
      fullPath: '/prompts'
      preLoaderRoute: typeof PromptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/investor': {
      id: '/investor'
      path: '/investor'
      fullPath: '/investor'
      preLoaderRoute: typeof InvestorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import': {
      id: '/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof ImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/git': {
      id: '/git'
      path: '/git'
      fullPath: '/git'
      preLoaderRoute: typeof GitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/effort': {
      id: '/effort'
      path: '/effort'
      fullPath: '/effort'
      preLoaderRoute: typeof EffortRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/decisions': {
      id: '/decisions'
      path: '/decisions'
      fullPath: '/decisions'
      preLoaderRoute: typeof DecisionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contributors': {
      id: '/contributors'
      path: '/contributors'
      fullPath: '/contributors'
      preLoaderRoute: typeof ContributorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compliance': {
      id: '/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof ComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/classifier-tuning': {
      id: '/classifier-tuning'
      path: '/classifier-tuning'
      fullPath: '/classifier-tuning'
      preLoaderRoute: typeof ClassifierTuningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-reports': {
      id: '/ai-reports'
      path: '/ai-reports'
      fullPath: '/ai-reports'
      preLoaderRoute: typeof AiReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-models': {
      id: '/ai-models'
      path: '/ai-models'
      fullPath: '/ai-models'
      preLoaderRoute: typeof AiModelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup_/success': {
      id: '/signup_/success'
      path: '/signup/success'
      fullPath: '/signup/success'
      preLoaderRoute: typeof SignupSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup_/authenticate': {
      id: '/signup_/authenticate'
      path: '/signup/authenticate'
      fullPath: '/signup/authenticate'
      preLoaderRoute: typeof SignupAuthenticateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prompts/$promptKey': {
      id: '/prompts/$promptKey'
      path: '/$promptKey'
      fullPath: '/prompts/$promptKey'
      preLoaderRoute: typeof PromptsPromptKeyRouteImport
      parentRoute: typeof PromptsRoute
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface PromptsRouteChildren {
  PromptsPromptKeyRoute: typeof PromptsPromptKeyRoute
}

const PromptsRouteChildren: PromptsRouteChildren = {
  PromptsPromptKeyRoute: PromptsPromptKeyRoute,
}

const PromptsRouteWithChildren =
  PromptsRoute._addFileChildren(PromptsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiModelsRoute: AiModelsRoute,
  AiReportsRoute: AiReportsRoute,
  AuditRoute: AuditRoute,
  BillingRoute: BillingRoute,
  ClassifierTuningRoute: ClassifierTuningRoute,
  ComplianceRoute: ComplianceRoute,
  ContributorsRoute: ContributorsRoute,
  DashboardRoute: DashboardRoute,
  DecisionsRoute: DecisionsRoute,
  EffortRoute: EffortRoute,
  GitRoute: GitRoute,
  ImportRoute: ImportRoute,
  IntegrationsRoute: IntegrationsRoute,
  InvestorRoute: InvestorRoute,
  PromptsRoute: PromptsRouteWithChildren,
  ReportsRoute: ReportsRoute,
  SessionsRoute: SessionsRoute,
  SettingsRoute: SettingsRoute,
  SignupRoute: SignupRoute,
  TechnicalUncertaintyRoute: TechnicalUncertaintyRoute,
  WelcomeRoute: WelcomeRoute,
  WorkItemsRoute: WorkItemsRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ShareTokenRoute: ShareTokenRoute,
  SignupAuthenticateRoute: SignupAuthenticateRoute,
  SignupSuccessRoute: SignupSuccessRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
